import React, { memo, useCallback, useEffect, useState } from 'react'

import { Inline, Checkbox } from '~/components'

function Statuses({ param, setParam }) {
  const [selecteds, setSelecteds] = useState([])

  const statuses = [
    { status: 'PROGRESS', label: 'Em Andamento' },
    { status: 'FINISHED', label: 'Finalizado' }
  ]

  useEffect(() => {
    if (!Array.isArray(param) && param) {
      const select = param.split(',')

      setSelecteds(select.map((item) => item))

      setParam(select)
    } else {
      if (param) {
        setSelecteds(param.map((item) => item))
      }
    }
  }, [setParam, param])

  const changeSelected = useCallback(
    (value) => {
      const selected = selecteds.find(selected => selected === value)
      if (selected) {
        setParam(selecteds.filter((item) => item !== value))
      } else {
        setParam([...selecteds, value])
      }
    },
    [setParam, selecteds]
  )

  return (
    <>
      <div className="my-5 mx-6 px-3" style={{ minHeight: 50 }}>
        <Inline right={30} className="mb-5" mobileCenter style={{ justifyContent: 'center', flex: 1 }}>
          {statuses.map((item, key) => (
            <Checkbox
              key={key}
              id={`checkbox-${item.label}`}
              aria-label={item.label}
              name="status"
              value={item.status}
              checked={selecteds.length && !!selecteds.find(i => i === item.status)}
              onChange={() => changeSelected(item.status)}
            >
              {item.label}
            </Checkbox>
          ))}
        </Inline>
      </div>
    </>
  )
}

export default memo(Statuses)
